import React from 'react';

import { ProfileData } from 'hooks/useAuth';
import { GroupData } from 'hooks/useMemberGroupData';

import { formatDateTime, getRelationshipToToday } from 'libs/utils';
import { Bumper, Card } from 'styles/shared';
import { Fonts, spacing, transparencies } from 'styles/theme';
import { Button } from 'styles/button';

interface GroupCardProps {
    group: GroupData;
    userProfile: ProfileData | null;
    coachProfile?: ProfileData;
    onClick: (gid: string) => () => void;
}

export const GroupCard = ({
    group,
    userProfile,
    coachProfile,
    onClick,
}: GroupCardProps) => {
    const shouldShowCoachName = !userProfile?.coach_groups?.includes(group.gid);
    const nextSessionRelationship =
        group.next_session_date == null
            ? 'none'
            : getRelationshipToToday(new Date(group.next_session_date));

    return (
        <Card
            $width="280px"
            $backgroundColor={transparencies.darkJungle5}
            style={{ justifyContent: 'space-between' }}
        >
            <Fonts.Heading5>{group.gid}</Fonts.Heading5>
            <div>
                <Bumper $minHeight={spacing.small} />
                {shouldShowCoachName && coachProfile != null ? (
                    <>
                        <Fonts.Medium $isOpenSansSemiBold>
                            {`Coach: ${coachProfile.full_name}`}
                        </Fonts.Medium>
                        <Bumper $minHeight={spacing.xxSmall} />
                    </>
                ) : null}
                {nextSessionRelationship === 'none' ? null : (
                    <>
                        <Fonts.Small>{`${
                            nextSessionRelationship === 'upcoming'
                                ? `Next`
                                : nextSessionRelationship === 'current'
                                ? `Today's`
                                : 'Final'
                        } session date: ${formatDateTime(
                            new Date(group.next_session_date ?? 0)
                        )}`}</Fonts.Small>
                        <Bumper $minHeight={spacing.small} />
                    </>
                )}
                <Button
                    onClick={onClick(group.gid)}
                >{`See group details`}</Button>
            </div>
        </Card>
    );
};
